import { useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material';
import { StyledTableCellWithoutLeftRight } from 'routes/Main/style';
import Form from 'components/Form';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';

const contentLabel = [
  {
    id: 1,
    desc: [
      '체위변경: 스스로 앙와위에서 측와위로 변경할 수 있는지 평가',
      '침상 밖으로 이동: 스스로 침상 내에서 침상 밖으로 이동이 가능한지 평가',
      '식사섭취: 스스로 식사 섭취가 가능한지 평가',
    ],
    scores: [1, 1, 1],
    ids: [1, 2, 3],
  },
  {
    id: 2,
    desc: [
      '배변·배뇨: 스스로 배변·배뇨에 관련된 행위를 할 수 있는지 평가',
      '개인위생: 스스로 개인위생에 관련된 행위를 할 수 있는지 평가',
      '옷 입기: 스스로 옷을 입고 벗을 수 있는지 평가',
    ],
    scores: [1, 1, 1],
    ids: [4, 5, 6],
  },
];

const contentLabelTwo = [
  {
    id: 1,
    desc: ['지시이행 및 정서 상태: 정서적 불안정, 위험행동관리 포함하여 평가 '],
    scores: [2],
    ids: [7],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}

const Contents3 = (props: Props) => {
  const { palette } = useTheme();
  const { disabled, setValue, getValues, register } = props;

  const min = 0;
  const max = 5;

  const [input1, setInput1] = useState(
    getValues('no04_01') ? Number(getValues('no04_01')) : 0
  );
  const [input2, setInput2] = useState(
    getValues('no04_02') ? Number(getValues('no04_02')) : 0
  );
  const [input3, setInput3] = useState(
    getValues('no04_03') ? Number(getValues('no04_03')) : 0
  );
  const [input4, setInput4] = useState(
    getValues('no04_04') ? Number(getValues('no04_04')) : 0
  );
  const [input5, setInput5] = useState(
    getValues('no04_05') ? Number(getValues('no04_05')) : 0
  );
  const [input6, setInput6] = useState(
    getValues('no04_06') ? Number(getValues('no04_06')) : 0
  );

  const [input7, setInput7] = useState(
    getValues('no04_07') ? Number(getValues('no04_07')) : 0
  );

  return (
    <>
      <SectionTitle
        title="4. 측정항목 - B항목.일상생활수행능력 및 정서 상태(코드번호로 기재)"
        mb={3}
        mt={3}
      />
      <Box sx={{ width: '98%', margin: '20px auto' }}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCellWithoutLeftRight
                align="left"
                sx={{
                  padding: '16px',
                  color: `${palette.primary.main}`,
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                항목
              </StyledTableCellWithoutLeftRight>
              <StyledTableCellWithoutLeftRight
                align="center"
                sx={{
                  padding: '16px',
                  color: `${palette.primary.main}`,
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    marginLeft: '-15px',
                  }}
                >
                  0: 의존없음 <br />
                  1: 의존있음
                </Typography>
              </StyledTableCellWithoutLeftRight>
            </TableRow>
          </TableHead>
          <TableBody>
            {contentLabel.map(
              (content: {
                id: number;
                desc: string[];
                scores: number[];
                ids: number[];
              }) => (
                <TableRow>
                  <StyledTableCellWithoutLeftRight>
                    {content.desc.map((v, i) => (
                      <TableRow
                        sx={{
                          height: '48px',
                          lineHeight: '48px',
                          borderBottom:
                            i !== content.desc.length - 1
                              ? '1px solid lightgray'
                              : '',
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{
                            paddingLeft: '16px',
                            fontSize: '12px',
                            width: '82.6vw',
                            maxWidth: '1340px',
                            minWidth: '1088px',
                            fontWeight: 500,
                          }}
                        >
                          {v}
                        </Box>
                      </TableRow>
                    ))}
                  </StyledTableCellWithoutLeftRight>
                  <StyledTableCellWithoutLeftRight>
                    {content.scores.map((score, i) => {
                      return (
                        <TableRow
                          sx={{
                            height: '48px',
                            textAlign: 'center',
                            borderBottom:
                              i !== content.desc.length - 1
                                ? '1px solid lightgray'
                                : '',
                          }}
                        >
                          <Box
                            sx={{
                              width: '130px',
                              height: '48px',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Form.MuiTextField
                              disabled={disabled}
                              required={false}
                              type="number"
                              inputProps={{ min, max }}
                              value={
                                content.desc[i].includes('체위변경')
                                  ? input1
                                  : content.desc[i].includes(
                                      String('침상 밖으로 이동')
                                    )
                                  ? input2
                                  : content.desc[i].includes(String('식사섭취'))
                                  ? input3
                                  : content.desc[i].includes(
                                      String('배변·배뇨')
                                    )
                                  ? input4
                                  : content.desc[i].includes(
                                      String('개인위생: 스스로')
                                    )
                                  ? input5
                                  : content.desc[i].includes(String('옷 입기:'))
                                  ? input6
                                  : 0
                              }
                              {...register(`no04_0${content.ids[i]}`, {
                                onChange: e => {
                                  var value = parseInt(e.target.value, 10);

                                  let max = { score };

                                  if (value >= max.score) value = max.score;
                                  if (value < min) value = min;

                                  if (content.desc[i].includes('체위변경'))
                                    setInput1(value);
                                  else if (
                                    content.desc[i].includes('침상 밖으로 이동')
                                  )
                                    setInput2(value);
                                  if (content.desc[i].includes('식사섭취'))
                                    setInput3(value);
                                  if (content.desc[i].includes('배변·배뇨'))
                                    setInput4(value);
                                  if (
                                    content.desc[i].includes('개인위생: 스스로')
                                  )
                                    setInput5(value);
                                  if (content.desc[i].includes('옷 입기:'))
                                    setInput6(value);
                                },
                              })}
                            />
                          </Box>
                        </TableRow>
                      );
                    })}
                  </StyledTableCellWithoutLeftRight>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </Box>

      <Box sx={{ width: '98%', margin: '-21px auto' }}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCellWithoutLeftRight
                align="left"
                sx={{
                  padding: '16px',
                  color: `${palette.primary.main}`,
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                항목
              </StyledTableCellWithoutLeftRight>
              <StyledTableCellWithoutLeftRight
                align="center"
                sx={{
                  padding: '16px',
                  color: `${palette.primary.main}`,
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    marginLeft: '-15px',
                  }}
                >
                  0: 안정
                  <br />
                  1: 지시불이행 <br />
                  2: 위험행동 집중관찰
                </Typography>
              </StyledTableCellWithoutLeftRight>
            </TableRow>
          </TableHead>
          <TableBody>
            {contentLabelTwo.map(
              (content: {
                id: number;
                desc: string[];
                scores: number[];
                ids: number[];
              }) => (
                <TableRow>
                  <StyledTableCellWithoutLeftRight>
                    {content.desc.map((v, i) => (
                      <TableRow
                        sx={{
                          height: '48px',
                          lineHeight: '48px',
                          borderBottom:
                            i !== content.desc.length - 1
                              ? '1px solid lightgray'
                              : '',
                          width: '100%',
                        }}
                      >
                        <Box
                          sx={{
                            paddingLeft: '16px',
                            fontSize: '12px',
                            width: '82.6vw',
                            maxWidth: '1340px',
                            minWidth: '1088px',
                            fontWeight: 500,
                          }}
                        >
                          {v}
                        </Box>
                      </TableRow>
                    ))}
                  </StyledTableCellWithoutLeftRight>
                  <StyledTableCellWithoutLeftRight>
                    {content.scores.map((score, i) => {
                      return (
                        <TableRow
                          sx={{
                            height: '48px',
                            textAlign: 'center',
                            borderBottom:
                              i !== content.desc.length - 1
                                ? '1px solid lightgray'
                                : '',
                          }}
                        >
                          <Box
                            sx={{
                              width: '130px',
                              height: '48px',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Form.MuiTextField
                              disabled={disabled}
                              required={false}
                              type="number"
                              inputProps={{ min, max }}
                              value={
                                content.desc[i].includes('지시이행')
                                  ? input7
                                  : 0
                              }
                              {...register(`score4_2[${content.ids[i]}]`, {
                                onChange: e => {
                                  var value = parseInt(e.target.value, 10);

                                  let max = { score };

                                  if (value >= max.score) value = max.score;
                                  if (value < min) value = min;

                                  if (content.desc[i].includes('지시이행'))
                                    setInput7(value);
                                },
                              })}
                            />
                          </Box>
                        </TableRow>
                      );
                    })}
                  </StyledTableCellWithoutLeftRight>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'flex-end'}
          sx={{ marginTop: '20px' }}
        >
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            variant="subtitle1"
          >
            {/* 합계: {total}점 */}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Contents3;
